import { SearchRoundedIcon, TextField, Flex } from '@shared/components';
import debounce from 'lodash/debounce';

import { useExamEventSessionExamineeSearchParams } from '../../hooks';

export default function ExamSessionExamineeSearchBox() {
  const [{ search }, { changeSearch }] = useExamEventSessionExamineeSearchParams();

  const debouncedSearch = debounce((searchString: string) => {
    changeSearch(searchString);
  }, 700);

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(4),
      })}
    >
      <TextField
        defaultValue={search}
        placeholder='ค้นหาชื่อผู้เข้าสอบ'
        name='search'
        slotProps={{
          input: {
            startAdornment: (
              <SearchRoundedIcon sx={{ color: (theme) => theme.palette.grey[500] }} />
            ),
          },
        }}
        sx={{
          width: '300px',
        }}
        onChange={(event) => {
          debouncedSearch(event.target.value);
        }}
      />
    </Flex>
  );
}
